export default "__VITE_ASSET__D2xnp8sF__"